import * as apiUtils from "./apiUtils";
const baseUrl = process.env.API_URL + "/PaymentMethods/";
const baseUrl1 = process.env.API_URL;

export function updatePaymentMethod(RecurringPaymentCardID, params) {
  return apiUtils
    .put(`${baseUrl}UpdateCard`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function createPaymentMethod(params) {
  return apiUtils
    .post(`${baseUrl}AddCard`, params)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}
export function getPaymentMethod(ClientId) {
  return apiUtils
    .get(`${baseUrl}${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}

export function getClientPaymentToken(ClientId) {
  return apiUtils
    .get(`${baseUrl1}/ClientPayments/GetToken/${ClientId}`)
    .then(apiUtils.handleResponse)
    .catch(apiUtils.handleError);
}